export const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M12.6663 8.66683H8.66634V12.6668H7.33301V8.66683H3.33301V7.3335H7.33301V3.3335H8.66634V7.3335H12.6663V8.66683Z"
      fill="currentColor"
    />
  </svg>
);
